import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Product_Create, Product_Delete, Product_FetchDetail, Product_GetLoanSlabs, Product_ReadAll, Product_ReadById, Product_ReadByProductCode, Product_ReadByProductType, Product_Update } from 'src/app/GlobalVariable';
import { LoanSlabRequestDTO, LoanSlabResponseDTO, ProductCreateRequestDTO, ProductDeleteRequestDTO, ProductDetailsDTO, ProductDTO, ProductList, ProductReadByIdRequestDTO, ProductReadByProductCodeRequestDTO, ProductReadByProductTypeRequestDTO, ProductUpdateRequestDTO } from './product.interface';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor() { }
  http = inject(HttpClient)

  Product_ReadAll(): Observable<ProductList> {
    return this.http.get<ProductList>(Product_ReadAll)
  }
  Product_Create(product: ProductCreateRequestDTO): Observable<ProductDTO> {
    return this.http.post<ProductDTO>(Product_Create, product);
  }

  Product_Update(product: ProductUpdateRequestDTO): Observable<ProductDTO> {
    return this.http.post<ProductDTO>(Product_Update, product);
  }

  Product_Delete(data: ProductDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(Product_Delete, data)
  }

  Product_ReadById(data: ProductReadByIdRequestDTO): Observable<ProductDTO> {
    return this.http.post<ProductDTO>(Product_ReadById, data);
  }
  Product_FetchDetails(data: ProductReadByIdRequestDTO): Observable<ProductDetailsDTO> {
    return this.http.post<ProductDetailsDTO>(Product_FetchDetail, data);
  }

  Product_ReadByProductType(data: ProductReadByProductTypeRequestDTO): Observable<ProductList> {
    return this.http.post<ProductList>(Product_ReadByProductType, data);
  }
  Product_ReadByProductCode(data: ProductReadByProductCodeRequestDTO): Observable<ProductDTO> {
    return this.http.post<ProductDTO>(Product_ReadByProductCode, data);
  }
  Product_GetLoanSlabs(data: LoanSlabRequestDTO): Observable<LoanSlabResponseDTO>{
    return this.http.post<LoanSlabResponseDTO>(Product_GetLoanSlabs, data);
  }
}
